import React from "react";
import { Camera } from "lucide-react";

interface ScannerReticleProps {
  isScanning: boolean;
}

export const ScannerReticle: React.FC<ScannerReticleProps> = ({ isScanning }) => {
  if (!isScanning) {
    return (
      <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center text-slate-400 bg-slate-950">
        <Camera className="w-10 h-10 mb-2 opacity-50 animate-bounce" />
        <p className="text-xs font-semibold">Opening Camera...</p>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-center">
      <div className="relative w-[92%] h-[26%] sm:w-[88%] sm:h-[30%] rounded-2xl border-2 border-white/50 shadow-[0_0_20px_rgba(255,255,255,0.15)] z-10 flex flex-col justify-between p-1 bg-transparent">
        <div className="absolute -top-1 -left-1 w-6 h-6 border-t-4 border-l-4 border-emerald-400 rounded-tl-lg" />
        <div className="absolute -top-1 -right-1 w-6 h-6 border-t-4 border-r-4 border-emerald-400 rounded-tr-lg" />
        <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-4 border-l-4 border-emerald-400 rounded-bl-lg" />
        <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-4 border-r-4 border-emerald-400 rounded-br-lg" />
        <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-red-500 to-transparent shadow-[0_0_10px_red] animate-[scan_2s_infinite_linear]" />
      </div>
    </div>
  );
};
